import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Full-viewport kinetic breaker between chapters.
 * A huge word slides across horizontally as user scrolls through it,
 * with the color changing to the incoming chapter accent.
 */
const KineticBreaker = ({ word, accent = "#ec4899", tilt = 0 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const x = useTransform(scrollYProgress, [0, 1], ["30vw", "-90vw"]);
  const opacity = useTransform(
    scrollYProgress,
    [0, 0.15, 0.85, 1],
    [0, 1, 1, 0]
  );

  return (
    <section
      ref={ref}
      className="relative h-[50vh] md:h-[65vh] w-full flex items-center overflow-hidden bg-[#050505] border-y border-white/5"
      aria-hidden="true"
    >
      <motion.div
        style={{ x, opacity, color: accent, rotate: tilt }}
        className="font-display uppercase whitespace-nowrap text-[36vw] md:text-[28vw] leading-none select-none tracking-[-0.03em]"
      >
        {word}
        <span className="opacity-40 mx-8">·</span>
        {word}
      </motion.div>

      {/* thin animated hairline */}
      <motion.div
        style={{ scaleX: scrollYProgress }}
        className="absolute bottom-0 left-0 right-0 h-px origin-left"
      >
        <div className="h-full w-full" style={{ background: accent }} />
      </motion.div>
    </section>
  );
};

export default KineticBreaker;
